// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const SupportIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M17.87 4.86c.46-.46.43-1.21-.1-1.57-1.68-1.13-3.7-1.79-5.87-1.79s-4.19.66-5.86 1.79c-.54.36-.56 1.11-.1 1.57l2.1 2.1.02.02.68.69c.38.37.96.41 1.45.21q.8-.33 1.71-.34.9 0 1.71.34c.5.2 1.08.16 1.45-.21l.69-.69.02-.02zm.26 15.6c.33-.24.34-.72.06-1l-.01-.01-3.12-3.12c-.37-.37-.96-.41-1.45-.2q-.8.31-1.7.33-.92 0-1.71-.34c-.5-.2-1.08-.16-1.46.21l-.7.7v.01l-2.1 2.1c-.46.46-.44 1.21.1 1.57 1.67 1.13 3.7 1.8 5.86 1.8 2.33 0 4.49-.77 6.23-2.05"
        opacity=".5"
      />
      <path d="M19.14 17.87c.46.46 1.21.43 1.57-.1 1.13-1.68 1.8-3.7 1.8-5.87s-.67-4.19-1.8-5.86c-.36-.54-1.11-.56-1.57-.1l-2.1 2.1-.02.02-.69.68c-.37.38-.41.96-.2 1.45q.31.8.33 1.71 0 .92-.34 1.71c-.2.5-.16 1.08.21 1.45l.69.69.03.02zm-15.59.26c.24.33.7.34 1 .06v-.01l3.12-3.12c.37-.37.41-.96.21-1.45q-.33-.8-.34-1.7 0-.92.34-1.71c.2-.5.16-1.08-.21-1.46l-.7-.7h-.01l-2.1-2.1c-.46-.46-1.21-.44-1.57.1C2.16 7.7 1.5 9.74 1.5 11.9c0 2.33.76 4.49 2.05 6.23" />
    </g>
  </SvgIcon>
);

export default SupportIcon;
